import { CourseDef } from '../../types';

import { realityTrader } from './courses/realityTrader/_index';
import { estrategiasOTC } from './courses/estrategiasOTC/_index';
import { tradeNaPratica } from './courses/tradeNaPratica/_index';

export const module3Name = '3️⃣ - CONTEÚDOS NA QUOTEX (CORRETORA DE RETRAÇÃO)';

// DEPRECATED: conversão temporária substituída pelo array definitivo abaixo
// export const module3Courses: CourseDef[] = module3Sidebar.map(group => ({
//   courseTitle: group.title,
//   lessons: group.items.map(it => ({
//     itemId: (it.href || '').split('?')[0].split('/').filter(Boolean).pop() || '',
//     title: it.label,
//     video: { platform: 'youtube', videoId: 'VIDEO_ID_AJUSTAR' },
//     article: ['Preencha o conteúdo desta aula neste arquivo quando migrarmos individualmente.'],
//   })),
// }));

export const module3Courses: CourseDef[] = [
  realityTrader,
  estrategiasOTC,
  tradeNaPratica,
];

